<div fxLayout="column" *ngIf="tableSkeletonService.skeletonShow" fxLayoutGap="7px">
    <div fxFlex="0 1 100%">
        <ngx-skeleton-loader
            count="1"
            appearance="line"
            SkeletonLoader
            [theme]="{
                height: '32px',
                'background-color': bgColor
            }">
        </ngx-skeleton-loader>
    </div>
    <ng-container *ngIf="!tableSkeletonService.isOneLineSkeleton">
        <div fxFlex="0 1 100%" fxLayoutGap="5px" fxLayout="row" class="spinner-skeleton-row spinner-skeleton-col">
            <ngx-skeleton-loader
                fxFlex="0 1 100%"
                *ngFor="let i of [1,2,3,4,5,6]"
                count="1" appearance="line"
                SkeletonLoader
                [theme]="{
                    height: '32px',
                    'background-color': bgColor
                }">
            </ngx-skeleton-loader>
        </div>
    </ng-container>
</div>
